import { Component, ElementRef, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { GestaoFinanceiraService } from "../gestao-financeira.service";
import { NotificationsService } from "angular2-notifications";
import { debounceTime } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";

interface IFormGroupProps {
  bloqueioFinanceiro: boolean
  observacao: string
}

@Component({
  selector: 'ngx-modal-bloqueio-financeiro',
  templateUrl: './modal-bloqueio-financeiro.component.html',
  styleUrls: ['./modal-bloqueio-financeiro.component.scss']
})
export class ModalBloqueioFinanceiroComponent<T> implements OnInit {
  public customLogin = null;

  @Input() bloqueioFinanceiro: boolean
  @Input() observacao: string
  public strLen: number = 0;
  

  @ViewChild("card", {} as {
    read?: any;
    static: boolean;
  })
  private card: ElementRef;
  public formGroup: FormGroup;

  constructor(
    protected ref: NbDialogRef<ModalBloqueioFinanceiroComponent<T>>,
    private readonly formBuilder: FormBuilder,
    private readonly service: GestaoFinanceiraService,
    private readonly notificationsService: NotificationsService,
    private readonly spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.card.nativeElement.ownerDocument.activeElement.blur();
    this.createForm({ bloqueioFinanceiro: this.bloqueioFinanceiro, observacao: ''})
  }

  createForm(data: IFormGroupProps): void {
    const group = {
      bloqueioFinanceiro: data.bloqueioFinanceiro,
      observacao: data.observacao
    }
    this.formGroup = this.formBuilder.group(group);

    this.updateValidatorsControl('observacao', [Validators.required, Validators.minLength(30), Validators.maxLength(1000)]);
    this.formGroup.get('observacao').valueChanges.pipe(debounceTime(1)).subscribe((value: string) => {
      if (value != null || value.length != 0) {
        this.strLen = value.length
      } else {
        this.strLen = 0;
      }
    })
  }

  saveFinancialBlock() {
    this.spinnerService.show();
    if (this.formGroup.invalid) {
			this.notificationsService.error('Informações obrigatórios não informadas ou inválidas!');
      this.spinnerService.hide();
			return null;
		}

    const data: IFormGroupProps = this.formGroup.getRawValue()
    this.service.salvarBloqueioFinanceiro({
      bloqueioFinanceiro: !data.bloqueioFinanceiro,
      observacao: data.observacao
    }, (() => {
      this.clearForm();
      this.ref.close(data);
      this.notificationsService.success('Operação realizada com sucesso!');
    }), (error: { message: string; }) => {
      this.notificationsService.error(error.message);
      this.spinnerService.hide();
    });
  }

  clearForm() {
    this.formGroup = this.formBuilder.group({
      bloqueioFinanceiro: [
        { value: this.bloqueioFinanceiro },
        Validators.compose([Validators.required])
      ],
      observacao: [
        { value: null },
        Validators.compose([Validators.required, Validators.minLength(30)])
      ]
    });
    this.bloqueioFinanceiro = null;
  }

  voltar() {
    this.ref.close();
  }

  private updateValidatorsControl(controlName: string, validators: ValidatorFn[] | null): void {
		const control = this.formGroup.get(controlName);
		control.setValidators(validators);
		control.updateValueAndValidity();
	}

  getTextInfoHeader(): string {
    return `Você está ${this.bloqueioFinanceiro ? 'desbloqueando' : 'bloqueando'} esse usuário.`
  }

  getTextInfoBody(): string {
    return `Ao ${this.bloqueioFinanceiro ? 'desbloqueá-lo ele' : 'bloqueá-lo ele não'} poderá acessar os produtos e serviços disponíveis no aplicativo.`
  }

}